import {TimedPoint} from "./timed-point";

export class Dataset {
    constructor(readonly timedData: readonly TimedPoint[]) {
    }
}
